import React, { Component } from "react";
import {
  // Col,
  // Container,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  // Row,
  // Button,
  // Alert,
} from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { ValueType } from "react-select/src/types";
import { bindActionCreators, Dispatch } from "redux";
// import { APP_NAME } from "../../constants";
import { ApplicationState } from "../../store";
import {
  getRegistrationDistricts,
  registerNewDistrict,
} from "../../store/auth/actions";
import { NewDistrictRegistrationCredential } from "../../store/auth/types";
import { USState, USStateNamesValues } from "../common/States";
// import { TermsAndConditionsModal } from "./terms-and-conditions/TermsAndConditionsModal";
import { ReactSelectOption } from "../../store/onboarding/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { validatePasswordWithDOM } from "../../utils/PasswordValidation";

// const trialSelectOptions: ReactSelectOption<"coach" | "district">[] = [
//   { label: "Whole District Trial", value: "district" },
//   // { label: "Coach Trial", value: "coach" },
// ];

type PropsFromState = {
  isLoading: boolean;
  error?: string;
};

type Props = PropsFromState & {
  registerNewDistrict: (
    district: NewDistrictRegistrationCredential,
    trialType: "coach" | "district"
  ) => any;
  onHide: () => void
};

type State = {
  user: NewDistrictRegistrationCredential;
  trial: "coach" | "district";
  passwordsMatch: boolean;
  isPasswordFieldsValid: boolean;
  //showTermsAndConditionsModal: boolean;
  attributeType: string;
  attributeConfirmType: string;
};

// const ALLOWED_PASSWORD_CHARS = /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{}:;"',.?/~`]*$/;
// const PASSWORD_PATTERN =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}:;"',.?/~`])[A-Za-z0-9!@#$%^&*()_+\-=[\]{}:;"',.?/~`]{8,20}$/;

class NewDistrictRegistrationPage extends Component<Props, State> {
  state: Readonly<State> = {
    user: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      district_name: "",
      state: undefined,
    },
    trial: "district",
    passwordsMatch: true,
    //showTermsAndConditionsModal: false,
    attributeType: "password",
    attributeConfirmType: "password",
    isPasswordFieldsValid: false,
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (prevProps.isLoading && !this.props.isLoading) {
      if (this.props.error) {
        let errorMessage = this.props.error;
        if (typeof this.props.error === "object") {
          if (this.props.error["non_field_errors"]) {
            errorMessage = this.props.error["non_field_errors"][0];
          } else {
            const firstKey = Object.keys(this.props.error)[0];
            errorMessage = this.props.error[firstKey][0];
          }
        }

      toastr.error("Error", errorMessage as string);
        // this.setState({
        //   showTermsAndConditionsModal: false,
        // });
      }
    }
  }

  handleTrialChange = (
    trial: ValueType<ReactSelectOption<"coach" | "district">, false>
  ) => {
    const item = trial as ReactSelectOption<"coach" | "district">;
    this.setState({
      trial: item.value,
    });
  };

  handleChange = (event: React.FormEvent<any>) => {
       const { name, value } = event.currentTarget;
   
       this.setState((prevState) => ({
           user: {
            ...prevState.user,
            [name]: value,
          },
         }), () => {
           const { password, password_confirmation } = this.state.user;
   
           const result = validatePasswordWithDOM(
             password,
             password_confirmation,
             "Password and Confirm Password fields do not match.",
             {
               newPasswordId: "new_password",
               newPasswordMsgId: "new_password_msg",
               confirmPasswordId: "confirm_new_password",
               confirmPasswordMsgId: "confirm_new_password_msg",
             }
           );
   
           this.setState({
             isPasswordFieldsValid: result.isPasswordFieldsValid,
             passwordsMatch: result.passwordsMatch,
           });
         }
       );
     };

  // handleChange = (event: React.FormEvent<any>) => {
  //   const { name, value } = event.target as HTMLInputElement;
  //   if (name === "password" || name === "password_confirmation") {
  //     if (!ALLOWED_PASSWORD_CHARS.test(value)) {
  //       return;
  //     }
  //   }
  //   let input, msg;
  //   if (name === "password") {
  //     input = document.getElementById("new_password");
  //     msg = document.getElementById("new_password_msg");
  //   }
  //   if (name === "password_confirmation") {
  //     input = document.getElementById("confirm_new_password");
  //     msg = document.getElementById("confirm_new_password_msg");
  //   }

  //   if (!PASSWORD_PATTERN.test(value) && value.length > 0 && (name === "password")) {
  //     if (input) input.style.border = "1px solid red";
  //     if (msg) msg.innerHTML = "Please match the format requested.";
  //   } else {
  //     if (input) input.style.border = "";
  //     if (msg) msg.innerHTML = "";
  //   }
  //   this.setState((prevState) => ({
  //     user: {
  //       ...prevState.user,
  //       [name]: value,
  //     },
  //     passwordsMatch: true,
  //   }));
  // };

  handleChangeState = (value: ValueType<USState, false>) => {
    const typedValue = value as USState;
    this.setState((prevState) => ({
      ...prevState,
      user: {
        ...prevState.user,
        state: typedValue.value,
      },
    }));
  };

  handleSubmit = (event: React.FormEvent<any>) => {
    event.preventDefault();
    // if (this.state.user.password !== this.state.user.password_confirmation) {
    //   this.setState({ passwordsMatch: false });
    //   const input = document.getElementById("confirm_new_password");
    //   const msg = document.getElementById("confirm_new_password_msg");
    //   if (input) input.style.border = "1px solid red";
    //   if (msg) msg.innerHTML = "Password and Confirm Password fields do not match.";
    //   return;
    // }
    // if (!PASSWORD_PATTERN.test(this.state.user.password)) {
    //   return;
    // }
    this.registerUser();
  };

  registerUser = () => {
    const { user, trial } = this.state;
    this.props.registerNewDistrict(user, trial).then((isRegistered: any) => {
      this.setState({
        passwordsMatch: true,
      });
      if(isRegistered) {
        this.props.onHide();
      }
    });
    
  };

  // handleShowTACModal = () => {
  //   this.setState({ showTermsAndConditionsModal: true });
  // };

  // handleHideTACModal = () => {
  //   this.setState({ showTermsAndConditionsModal: false });
  // };

  passwordShow = () => {
    this.setState({
      ...this.state,
      attributeType: this.state.attributeType === "password" ? "text": "password",
    })
  };

  confirmPasswordShow = () => {
    this.setState({
      ...this.state,
      attributeConfirmType: this.state.attributeConfirmType === "password" ? "text": "password",
    })
  };

  render() {
    const { isLoading, error } = this.props;
    const {
      user,
      trial,
      passwordsMatch,
      //showTermsAndConditionsModal,
      attributeType,
      attributeConfirmType
    } = this.state;

    const stateValue = user.state;
    return (
      <div>
         <Form onSubmit={this.handleSubmit} data-cy="sign-up-form">
                  {/* <h2 className="m-0 mb-3">
                    <strong>Sign up!</strong>
                  </h2> */}
                  {/* <FormGroup data-cy={"trial-type-group"}>
                    <FormLabel>
                      <h4>Trial Type</h4>
                    </FormLabel>
                    <FormControl
                      type="string"
                      value={trialSelectOptions[0].label}
                      className="fullWidthInput"
                      disabled={true}
                    /> */}
                    {/* <Select
                      options={trialSelectOptions}
                      value={
                        trialSelectOptions.find(
                          (item) => item.value === trial
                        ) ?? null
                      }
                      defaultValue={trialSelectOptions[0]}
                      onChange={this.handleTrialChange}
                      isDisabled={true}
                    /> */}
                  {/* </FormGroup> */}
                  <FormGroup controlId="validation_first_name">
                    <FormLabel>
                      <h4>First Name</h4>
                    </FormLabel>
                    <FormControl
                      required
                      autoFocus
                      name={"first_name"}
                      type="string"
                      value={user.first_name}
                      onChange={this.handleChange}
                      className="fullWidthInput"
                    />
                  </FormGroup>
                  <FormGroup controlId="validation_last_name">
                    <FormLabel>
                      <h4>Last Name</h4>
                    </FormLabel>
                    <FormControl
                      required
                      name={"last_name"}
                      type="string"
                      value={user.last_name}
                      onChange={this.handleChange}
                      className="fullWidthInput"
                    />
                  </FormGroup>
                  <FormGroup controlId="validation_email">
                    <FormLabel>
                      <h4>Your Email</h4>
                    </FormLabel>
                    <FormControl
                      required
                      name={"email"}
                      type="email"
                      value={user.email}
                      onChange={this.handleChange}
                      className="fullWidthInput"
                      isInvalid={typeof error === "string" && error.toLowerCase().includes("email")}
                    />
                  </FormGroup>
                  <FormGroup controlId="validation_password">
                    <FormLabel>
                      <h4>Password</h4>
                    </FormLabel>
                    <div className="input-container">
                      <FormControl
                        minLength={8}
                        maxLength={20}
                        required
                        name={"password"}
                        value={user.password}
                        onChange={this.handleChange}
                        type={attributeType}
                        id={`new_password`}
                        isInvalid={typeof error === "string" && error.toLowerCase().includes("password")}
                      />
                      {typeof error === "string" && error.toLowerCase().includes("password") && (
                        <div className="invalid-feedback d-block">
                          {error}
                        </div>
                      )}
                      <FontAwesomeIcon  
                        onClick={this.passwordShow}  
                        icon={attributeType == 'password' ? faEye : faEyeSlash} 
                        className="icon-eye"
                      />
                    </div>
                    <div id={`new_password_msg`} style={{color:"red"}}></div>
                    <ul className="password-rules">
                      <li>At least 8 to at most 20 characters long</li>
                      <li>At least one uppercase letter (A-Z)</li>
                      <li>At least one lowercase letter (a-z)</li>
                      <li>At least one number (0-9)</li>
                      <li>At least one non-alphanumeric character (! @ # $ % ^ & * ( ) _ + - = [ ] { } : ; ' " , . ? / ~ `)</li>
                    </ul>
                  </FormGroup>
                  <FormGroup controlId="validation_password_confirm">
                    <FormLabel>
                      <h4>Confirm Password</h4>
                    </FormLabel>
                    <div className="input-container">
                      <FormControl
                        minLength={8}
                        maxLength={20}
                        name={"password_confirmation"}
                        value={user.password_confirmation}
                        onChange={this.handleChange}
                        type={attributeConfirmType}
                        isInvalid={!passwordsMatch}
                        id={`confirm_new_password`}
                      />
                      <FontAwesomeIcon  
                        onClick={this.confirmPasswordShow}  
                        icon={attributeConfirmType == 'password' ? faEye : faEyeSlash} 
                        className="icon-eye"
                      />
                    </div>
                    <div id={`confirm_new_password_msg`} style={{color:"red"}}></div>
                    <Form.Control.Feedback type="invalid">
                      Passwords do not match.
                    </Form.Control.Feedback>
                  </FormGroup>
                  <FormGroup controlId="validation_password_confirm">
                    <FormLabel>
                      <h4>District Name</h4>
                    </FormLabel>
                    <FormControl
                      minLength={8}
                      maxLength={20}
                      name={"district_name"}
                      value={user.district_name}
                      onChange={this.handleChange}
                      type="string"
                    />
                  </FormGroup>
                  <Select
                    id={"state-selector"}
                    className="mt-4"
                    placeholder="Select State..."
                    name={"state"}
                    value={USStateNamesValues?.find(
                      (s) => s.value === stateValue
                    )}
                    options={USStateNamesValues}
                    getOptionLabel={({ display_name }: USState) => display_name}
                    getOptionValue={({ value }: USState) => value}
                    onChange={this.handleChangeState}
                    required
                  />
                  <div className="text-center mt-2">
                    <div>
                      <button
                        data-cy="submit-registration"
                        className="blueBtnMd m-4"
                        disabled={!stateValue || isLoading || !this.state.isPasswordFieldsValid}
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    {/* <div>
                      <a href={"/app/login"} className="clickableLabel">
                        Login
                      </a>
                    </div> */}
                  </div>
                </Form>
        {/* <TermsAndConditionsModal
          showModal={showTermsAndConditionsModal}
          handleHideModal={this.handleHideTACModal}
          isLoading={isLoading}
          onAccept={this.registerUser}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: ApplicationState): PropsFromState => {
  return {
    isLoading: auth.isLoading.registerUser,
    error: auth.errors.registerUser,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      registerNewDistrict: registerNewDistrict,
      getRegistrationDistricts: getRegistrationDistricts,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewDistrictRegistrationPage);
